module.exports = __webpack_public_path__ + "img/search.cfb9c146.svg";